import script from "./BaseDataView.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDataView.vue?vue&type=script&setup=true&lang=js"

import "./BaseDataView.vue?vue&type=style&index=0&id=077ba53f&lang=css"

const __exports__ = script;

export default __exports__